import React from "react";
import DeliveryRow from "./DeliveryRow";

// Each group shares one fixed grid (header and rows), so a long name or a problem note never moves a column.
export default function DeliveryTable({ groups, openMenuId, highlightId, ...rowProps }) {
  return groups.map((group) => (
    <section key={group.key} aria-label={group.title} className="md-group">
      <div className="md-group__head">
        <h2 className={`md-group__title${group.key === "attention" ? " md-group__title--attention" : ""}`}>
          {group.title}
        </h2>
        <span className="md-mono md-small md-muted">{group.rows.length}</span>
        {group.sub ? <span className="md-sub md-muted">{group.sub}</span> : null}
      </div>
      {group.rows.length === 0 ? (
        <div className="md-table md-table__empty">{group.emptyText}</div>
      ) : (
        <div role="table" aria-label={group.title} className="md-table">
          <div role="row" className="md-grid md-table__head">
            <span role="columnheader" className="md-ellipsis">
              Window
            </span>
            <span role="columnheader" className="md-ellipsis">
              Customer and address
            </span>
            <span role="columnheader" className="md-ellipsis">
              Status and carrier
            </span>
            <span role="columnheader">
              <span className="md-visually-hidden">Actions</span>
            </span>
          </div>
          {group.rows.map((row, index) => (
            <DeliveryRow
              key={row.id}
              row={row}
              first={index === 0}
              highlighted={row.id === highlightId}
              menuOpen={row.id === openMenuId}
              {...rowProps}
            />
          ))}
        </div>
      )}
    </section>
  ));
}
